import React from 'react';
import { Fade } from 'react-awesome-reveal';
import { Node } from '@uncinc/react-drupal-core';
import Container from '../../../components/Container';
import { DEFAULT_FADE_DURATION_MS } from '../../../config/constants';

const ViewSeriesAll = ({ entities, pager }) => {
  return (
    <div className="View SeriesAll">
      <Container>
        <div className="row">
          {entities.map((entity) => {
            const id = entity.getIn(['nid', '0', 'value']);
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const langcode = entity.getIn(['langcode', 0, 'value']);
            const className = 'col-md-4 col-sm-12';
            return (
              <div key={`${uuid}:${langcode}`} className={className}>
                <Fade triggerOnce duration={DEFAULT_FADE_DURATION_MS}>
                  <Node
                    id={id}
                    key={`${uuid}:${langcode}`}
                    isActivePath
                    entity={entity}
                    viewMode="teaser"
                  />
                </Fade>
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

export default ViewSeriesAll;
